import * as React from 'react';
import { Button, Dropdown } from '@sharefiledev/flow-web';
import { t } from '../../util';
export function BrowseFiles(props) {
  if (!props.fromComputer || !props.fromShareFile) {
    var onClick = function onClick(e) {
      e.currentTarget.blur();
      if (props.fromComputer) {
        return props.fromComputer();
      }
      return props.fromShareFile();
    };
    return /*#__PURE__*/React.createElement(Button.TextPrimary, {
      onClick: onClick
    }, props.children);
  }
  var optionsObj = [];
  if (props.additionalOptions) {
    props.additionalOptions.map(function (option) {
      optionsObj.push({
        children: option.sourceName,
        onClick: option.sourceAction
      });
    });
  }
  return /*#__PURE__*/React.createElement(Dropdown, {
    openOn: "hover",
    placement: props.attachRight ? 'bottom-end' : 'bottom',
    options: [props.fromShareFile && {
      children: t('citrix-files-ui:upload.from_sharefile'),
      onClick: props.fromShareFile
    }, props.fromComputer && {
      children: t('citrix-files-ui:upload.from_computer'),
      onClick: props.fromComputer
    }].concat(optionsObj)
  }, function (buttonProps) {
    return /*#__PURE__*/React.createElement(Button.TextPrimary, buttonProps, props.children);
  });
}